module.exports = __webpack_public_path__ + "img/bg_bot.cf8d924b.png";